export const stickyShrinkObserver = (entry, stickyElement, shrinkClass) => {
  if (stickyElement) {
    if (entry.intersectionRatio <= 0) {
      stickyElement.classList.add(shrinkClass)
    } else if (entry.intersectionRatio > 0) {
      stickyElement.classList.remove(shrinkClass)
    }
  }
}
